// extracted by mini-css-extract-plugin
module.exports = {"root":"CartButton_root__xAM-w","counter":"CartButton_counter__2VZnX"};